import { render } from "./ConfSliders.vue?vue&type=template&id=0dacb9d1"
import script from "./ConfSliders.vue?vue&type=script&lang=js"
export * from "./ConfSliders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__